<ng-container>
	<obg-m-dialog-layout #dialog>
		<account-facial_recognition_caf [cpf]="cpfNumber$ | async" [useFaceAuthenticator]="true">
		</account-facial_recognition_caf>
	</obg-m-dialog-layout>
</ng-container>
